import { useMutation } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useRegisterFreightManager = () => {
  const { token } = useContext(AuthContext);

  const registerFreightManager = async (formData) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/register/freightmanager`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Freight manager registration failed');
    }

    return response.json();
  };

  return useMutation(registerFreightManager);
};

export default useRegisterFreightManager;
